import { combineReducers } from 'redux'

import appStates from './AppStates/AppStates'
import contactPersons from './ContactPersonsReducer/ContactPersonsReducer'
import getAppBanner from './AppBannerReducer'
import getAppScroll from './AppScrollReducer'
import getDataReady from './DataReadyReducer'
import getSchools from './SchoolsReducer'
import getStudents from './StudentsReducer/StudentsReducer'
import getTheme from './ThemeReducer'
import getUser from './UserReducer'
import getChangelog from './ChangelogReducer'
import getEvaluationQuestions from './EvaluationQuestionsReducer'
import getFreeFields from './FreeFieldsReducer'
import schoolSections from './SchoolSectionsReducer/SchoolSectionsReducer'
import actTypeCategories from './ActTypeCategoriesReducer'
import institutionConstraints from './InstitutionConstraintsReducer/InstitutionConstraintsReducer'
import satisfactionRatioFilter from './SatisfactionRatioFilterReducer'
import shifts from './ShiftsReducer/ShiftsReducer'
import presets from './ShiftsPresetsReducer/ShiftsPresetsReducer'
import tags from './TagsReducer'
import pauseQuotas from './PauseQuotasReducer/PauseQuotasReducer'
import profileDatas from './ProfilPageReducer'
import quotas from './QuotasReducer/QuotasReducer'
import internships from './InternshipsReducer/InternshipsReducer'
import { localeReducer as locale } from 'react-localize-redux'
import shiftsManager from './ShiftsManagerReducer/ShiftsManagerReducer'
import studentsExtraInformations from './StudentsExtraInfos'
import internshipsManager from './InternshipsManagerReducer/InternshipsManagerReducer'

export default combineReducers({
  actTypeCategories: actTypeCategories,
  appStates: appStates,
  contactPersons: contactPersons,
  getAppBanner: getAppBanner,
  getAppScroll: getAppScroll,
  getDataReady: getDataReady,
  getSchools: getSchools,
  getStudents: getStudents,
  getTheme: getTheme,
  getUser: getUser,
  getChangelog: getChangelog,
  getEvaluationQuestions: getEvaluationQuestions,
  getFreeFields: getFreeFields,
  institutionConstraints: institutionConstraints,
  internships: internships,
  internshipsManager: internshipsManager,
  profileDatas: profileDatas,
  quotas: quotas,
  satisfactionRatioFilters: satisfactionRatioFilter,
  shifts: shifts,
  pauseQuotas: pauseQuotas,
  presets: presets,
  shiftsManager: shiftsManager,
  studentsExtraInformations: studentsExtraInformations,
  tags: tags,
  schoolSections: schoolSections,
  locale: locale
})
